import { isEmpty, isEqual, isNil, isString } from 'lodash';
import { i18n } from '@shared/util/i18n';
import { validateUrls } from '@shared/util/validate/url';
import { EditableField, Field } from './Field';

export type UrlComponentDataValue = {
  url: string;
};

export class UrlField implements EditableField {
  readonly items: UrlComponentDataValue[];
  readonly url: string;
  readonly fieldType = 'UrlField';

  constructor(urls: UrlComponentDataValue[]) {
    this.items = urls;
    // only supporting first URL for now
    this.url = this.items[0]?.url ?? '';
  }

  validate(): string | null {
    const urls = this.items.map(item => item.url);
    if (validateUrls(urls)) {
      return null;
    }
    return i18n('workflowTemplate.component.error.url.invalid');
  }

  isEqual(field: Field): boolean {
    return field instanceof UrlField && isEqual(this.items, field.items);
  }

  toFieldJson() {
    return this.items;
  }

  get isEmpty() {
    return isEmpty(this.items);
  }

  static fromFieldJson(jsonBlob: any): UrlField | null {
    if (Array.isArray(jsonBlob) && jsonBlob.every(isUrlComponentDataValue)) {
      return new UrlField(jsonBlob);
    } else {
      return null;
    }
  }
}

function isUrlComponentDataValue(jsonBlob: any): jsonBlob is UrlComponentDataValue {
  return !isNil(jsonBlob) && isString(jsonBlob.url);
}
